import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { Tag, TagId } from "constructs/Tag";
import { useTheme } from "@mui/material/styles";
import Chip from "@mui/material/Chip";
// import GeniusIcon from "assets/icons/site/content/components/CosmicHorror";
import SvgIcon from "@mui/material/SvgIcon";
// import { ReactComponent as TestIcon } from "assets/icons/site/content/locale/tokyo-locale.svg";
import { tags as tagMappings } from "assets/tags/index";
import Tooltip from "@mui/material/Tooltip";
import LabelIcon from "@mui/icons-material/Label";


export interface TagTooltipProps {
  descriptions: string | null | undefined;
};

const TagTooltip = (props: TagTooltipProps) => (
  <Box>
    {props.descriptions}
  </Box>
);

export type TagTooltipPlacement =     
| 'bottom-end'
| 'bottom-start'
| 'bottom'
| 'left-end'
| 'left-start'
| 'left'
| 'right-end'
| 'right-start'
| 'right'
| 'top-end'
| 'top-start'
| 'top';

export interface TagNameProps {
  id: TagId
  name: string;
  magnitude: number;
};


const TagName = (props: TagNameProps) => (
  <Stack direction='row' spacing={0.75}>
    <Typography>{props.name}</Typography>
    <Typography fontWeight='bold' fontSize='1em'>{(props.id === 1 || props.id === 2) ? null : `${props.magnitude.toFixed(1)}`}</Typography>
  </Stack>
)

export interface TagIconProps {
  tag: Tag;
  bgColor?: string;
  tooltipPlacement?: TagTooltipPlacement | undefined;
  onDelete?: ((event: any) => void) | undefined;
}

const TagIcon = ({tag, bgColor, tooltipPlacement, onDelete}: TagIconProps) => {
  const theme = useTheme();
  // const Icon =  createSvgIcon(<circle cx={12} cy={12} r={12}/>, tag.name);
  //

  const icon = tagMappings[tag.id]?.icon ?? LabelIcon ?? null;

  return (
    <Tooltip title={<TagTooltip descriptions={ tag.description }/> }
      placement={tooltipPlacement}
    >
      <span>
        <Chip
          size="medium"
          variant="filled"
          onDelete={ onDelete }
          sx={{
            ".MuiChip-icon": {
              // width: "48px",
              // height: "48px",
              fill: theme.palette.primary.main,
              stroke: theme.palette.primary.main,
            },
            height: "42px",
            ":hover": {
              cursor: "pointer",
              color: theme.palette.primary.light,
              ".MuiChip-icon": {
                fill: theme.palette.primary.light,
                stroke: theme.palette.primary.light,
              },
            },
          }}
          label={<TagName id={ tag.id } name={ tag.name } magnitude={ tag.magnitude } />}
          icon={
            icon ? (
              <SvgIcon component={icon} inheritViewBox fontSize="large" />
            ) : (
              <></>
            )
            // <GeniusIcon
            //   fontSize='large'
            //   // sx={{ width: '48px' }}
            //   fill={theme.palette.primary.main}
            //   stroke={theme.palette.primary.main}
            // />
          }
          // icon={ <Icon /> }
        />
      </span>
    </Tooltip>
  );
};

export default TagIcon;
